<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.33 7.33C4.88 6.97 6.08 5.78 6.44 4.22L7 2L7.56 4.22C7.92 5.78 9.12 6.97 10.67 7.33L13 8L10.67 8.67C9.12 9.03 7.92 10.22 7.56 11.78L7 14L6.44 11.78C6.08 10.22 4.88 9.03 3.33 8.67L1 8L3.33 7.33Z"
      fill="currentColor"
    />
    <path
      d="M11.5 2.5C11.96 2.38 12.32 2.02 12.44 1.56L12.67 0.67L12.89 1.56C13.02 2.02 13.37 2.38 13.83 2.5L14.67 2.67L13.83 2.83C13.37 2.96 13.02 3.31 12.89 3.78L12.67 4.67L12.44 3.78C12.32 3.31 11.96 2.96 11.5 2.83L10.67 2.67L11.5 2.5Z"
      fill="currentColor"
    />
    <path
      d="M11.5 12.5C11.96 12.38 12.32 12.02 12.44 11.56L12.67 10.67L12.89 11.56C13.02 12.02 13.37 12.38 13.83 12.5L14.67 12.67L13.83 12.83C13.37 12.96 13.02 13.31 12.89 13.78L12.67 14.67L12.44 13.78C12.32 13.31 11.96 12.96 11.5 12.83L10.67 12.67L11.5 12.5Z"
      fill="currentColor"
    />
  </svg>
</template>
